<template>
  <div>
    <!--品牌观光 -->
    <div class="BrandDisplay" style="margin-left: 0px;border: 1px solid rgb(235, 237, 240);">
      <div class="BrandDisplayRight">观光农业 </div>
      <a style="float:right;line-height:65px;">
        更多 >
      </a>
      <div style="float:right;line-height:65px;">
        <a-input-search
          autosize="true"
          placeholder="input search text"
          style="width:200px;line-height:65px;margin-top:15px">
          <a-button slot="enterButton" icon="search" style="background:#207e63">
          </a-button>
        </a-input-search>
      </div>
    </div>
    <div style="height:200px;border-style:solid;border-width:5px;border-color:#207e63;margin-top: 20px;">
      <a-row>
        <a-space direction="horizontal">
          <a-col :span="4" v-for="(item, index) of listData" :key="index" :value="item.title">
            <a-card hoverable >
              <img slot="cover" alt="example" :src="item.imgUrl" style="width: 160px;height:120px;overflow:hidden;" />
              <a-card-meta :title="item.pName" style="width: 160px;"> </a-card-meta>
            </a-card>
          </a-col>
        </a-space>
      </a-row>
    </div>
  </div>
</template>
<script>
import { SightseeingParkInfoWebPage } from '@/api/main/SightseeingParkInfoManage'
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      listData: ''
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.orgId = this.$route.query.orgId
      SightseeingParkInfoWebPage({ orgId: this.orgId }).then(res => {
      this.listData = ''
      this.listData = res.data.rows
      this.RegionalBrandData = res.data.rows
      })
    }
  }
}
</script>
<style scoped>
.BrandDisplayRight {
  float: left;
  font-weight: 800;
  font-size: 22px;
  line-height:65px;
  margin-left: 30px;
}
.ant-input-group-addon{
  background: #207e63;
}
</style>
